import { BaseModalController, IModal, ModalContext } from '../Modal'
import { SaveForLaterModal } from 'Components/modal/SavedForLaterModal/SavedForLaterModal'
import { holdTaskByUser } from 'Services/tasks.service'
import { createReactElement, UpdatableReactElement } from 'shared/utils/react.utils'

export type SaveForLaterModalMetaData = unknown

export class SaveForLaterModalController
    extends BaseModalController<SaveForLaterModalMetaData>
    implements IModal<SaveForLaterModalMetaData>
{
    static Id = 'save-for-later' as const
    constructor(modalContext: ModalContext) {
        super(modalContext, SaveForLaterModalController.Id)
    }

    createElement(): UpdatableReactElement {
        const onCancel = () => {
            this.setVisibility(false)
        }
        const onConfirm = async (payload?: { comment: string }) => {
            await this.holdTask(payload?.comment || '')
            this.setVisibility(false)
        }
        return createReactElement(SaveForLaterModal, {
            ...this.modalContext,
            getVisibility: this.getVisibility.bind(this),
            onCancel,
            onConfirm,
        })
    }

    private async holdTask(comment: string) {
        try {
            const taskState = this.modalContext.task.taskState.getCurrentState()
            if (!taskState) {
                console.error('Cannot save task: task state is not initialized')
                this.modalContext.task.showNotification(
                    'Cannot save task: task state is not initialized',
                    'error'
                )
                return
            }
            const draftOutputContainer =
                this.modalContext.task.taskState.getModifiedDraftOutputContainer(
                    this.modalContext.studio.taskConfig
                )
            if (!draftOutputContainer) {
                console.error('Cannot save task: task state is not initialized')
                this.modalContext.task.showNotification(
                    'Cannot save task: task state is not initialized',
                    'error'
                )
                return
            }

            await holdTaskByUser({
                userId: taskState.user_id,
                submissionId: taskState.submission.id,
                timeElapsedInSeconds: Math.floor(
                    this.modalContext.studio.taskManager.timer.getElapsedTime() / 1000
                ),
                draftOutputContainer: draftOutputContainer,
                message: comment, // This should be 'message' in the API call, but 'comment' from the modal
            })

            this.modalContext.task.navigateTask({
                type: 'success',
                message: 'Task saved for later successfully',
            })
        } catch (e) {
            this.modalContext.task.showNotification((e as Error).message, 'error')
            console.error('Error saving task for later:', e)
        }
    }
}
